import * as fs from 'fs';
import * as path from 'path';
import { colors } from './const';
import { resolveProjectRoot } from './resolve-project-root';
import { installBundleDepsIfMissing } from './install-manifest';
import { writeViteScaffoldFilesIfMissing } from './vite-scaffold';

const c = colors;

export interface SeedPhase5Options {
  projectRoot?: string;
  scenarioB?: boolean;
  fromMockup?: boolean;
}

function getSdkDocsRoot(): string {
  return path.join(__dirname, '..', '..', 'templates', 'docs');
}

function copyImplementationPlanTemplate(projectRoot: string, sdkDocsRoot: string): string {
  const dest = path.join(projectRoot, 'implementation_plan.md');
  if (fs.existsSync(dest)) {
    console.log(`${c.dim}   implementation_plan.md already exists — keeping${c.reset}`);
    return dest;
  }
  const template = path.join(sdkDocsRoot, 'survey-ui', 'implementation_plan.md');
  if (!fs.existsSync(template)) {
    throw new Error('seed-phase5: survey-ui/implementation_plan.md template not found in SDK');
  }
  fs.copyFileSync(template, dest);
  console.log(`${c.green}OK:${c.reset} Copied implementation_plan.md → project root`);
  return dest;
}

function writeDeployConfigDefault(projectRoot: string): void {
  const dest = path.join(projectRoot, 'survey-deploy-config.json');
  if (fs.existsSync(dest)) {
    console.log(`${c.dim}   survey-deploy-config.json already exists — keeping${c.reset}`);
    return;
  }
  const defaultConfig = {
    deploy: {
      target: 'aws',
      autoDeploy: false,
    },
  };
  fs.writeFileSync(dest, `${JSON.stringify(defaultConfig, null, 2)}\n`, 'utf8');
  console.log(`${c.green}OK:${c.reset} Wrote survey-deploy-config.json → project root`);
}

/**
 * Docs-only model: seed-phase5 no longer copies a component bundle or generates
 * survey-theme.css. It prepares the project scaffold (framework files), installs
 * bundle dependencies, drops the implementation_plan template, and seeds
 * survey-deploy-config.json for Step 7 deploy target.
 */
export function runSeedPhase5(options: SeedPhase5Options = {}): number {
  const projectRoot = resolveProjectRoot(options.projectRoot);
  const sdkDocsRoot = getSdkDocsRoot();

  console.log(`${c.bold}=== CFM SDK — seed-phase5 (scaffold) ===${c.reset}`);
  console.log(`${c.dim}Project: ${projectRoot}${c.reset}\n`);

  copyImplementationPlanTemplate(projectRoot, sdkDocsRoot);
  writeDeployConfigDefault(projectRoot);

  const depsResult = installBundleDepsIfMissing(projectRoot);
  if (!depsResult.ok) {
    return 1;
  }

  writeViteScaffoldFilesIfMissing(projectRoot);

  console.log(`\n${c.green}Scaffold complete${c.reset} — no components copied (author from the docs)`);
  console.log(`${c.dim}Agent tasks:${c.reset}`);
  console.log(`${c.dim}  1. Author SurveyPage + one component per fetched question type (see 03-ui-specs/*)${c.reset}`);
  console.log(`${c.dim}  2. Style to the client's design, or minimal-default-theme.md when none is given${c.reset}`);
  console.log(`${c.dim}Next: npx cfm-sdk verify-build --fast${c.reset}`);
  return 0;
}
